var OrganizationProfileSchema;

import BaseModel from '../base_model.js';

import Fieldable from '../concerns/fieldable.js';

export default OrganizationProfileSchema = class OrganizationProfileSchema extends BaseModel {
  constructor(attrs = {}) {
    super(attrs);
    this._makeFields(attrs.fields, {});
  }

  toJSON() {
    return _.extend(super.toJSON(), {
      fields_attributes: this._generateFieldAttributes()
    });
  }

};

OrganizationProfileSchema.assemble(Fieldable);
